import React, { useEffect, useState } from 'react'
import { Collapse } from '@material-ui/core'
import { AlertTitle } from '@material-ui/lab'
import { Alert } from 'components/public/alert/Alert'
import { Declaration } from 'services/api'

const Declarations: React.FC = () => {
  const [declarations, setDeclarations] = useState<any[]>([])
  const [declarationsBoxes, setDeclarationBoxes] = useState<any>([])

  useEffect(() => {
    async function getDeclarations(): Promise<any> {
      const { allActive } = new Declaration()
      const list = await allActive()
      const boxes = Array(list.items.length)
      boxes.fill(true)
      setDeclarations(list.items)
      setDeclarationBoxes(boxes)
    }
    getDeclarations()
  }, [])

  return (
    <>
      {declarations.length > 0 &&
        React.Children.toArray(
          declarations.map((i: any, index: number): any => {
            return (
              <Collapse in={declarationsBoxes[index]}>
                <Alert
                  severity="info"
                  style={{ margin: '0 1em 2rem 0' }}
                  onClose={() => {
                    const boxes = [...declarationsBoxes]
                    boxes[index] = false
                    setDeclarationBoxes(boxes)
                  }}
                >
                  {i.subject && <AlertTitle>{i.subject}</AlertTitle>}
                  {i.message}
                </Alert>
              </Collapse>
            )
          }),
        )}
    </>
  )
}

export default Declarations
